<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="page-title">
      <i class="pi pi-search"> </i>
      <label class="name">官民連携チャットルーム</label>

      <a
        pButton
        href="https://future-city.go.jp/platform/inquire/#kanminrenkei-chatroom"
        class="p-button-text">
        官民連携チャットルームのよくある質問へ<span class="p-button-icon p-button-icon-right pi pi-angle-right" aria-hidden="true"></span>
      </a>
    </div>

    <!-- ガード文言 -->
    <p>
      ※各会員の投稿内容について、当プラットフォーム及び運営事務局(内閣府)が管理・保証するものではありません。
    </p>

    <div class="search-flex">
      <!-- 検索条件入力 -->
      <div class="search-form-area">
        <div class="thread-button-container" *ngIf="loginUser && memberClassId != 3">
          <span class="button-description">新しい相談の書き込みもできます</span>
          <a
            pButton
            type="button"
            class="button1 thread-button"
            [attr.href]="'/pages/platform/l301/new'" target="_blank"
          >
            <span class="button-title">相談を書き込む</span>
            <span class="button-subtitle">（スレッド作成）</span>
          </a>
        </div>

      </div>

      <!-- 結果表示 -->
      <div class="result-area">
        <!-- ページアンカー -->
        <a id="jump-top"></a>

        <!-- 課題タイトル -->
        <div class="task-title">
          <!-- タイトルコンテンツ -->
          <div class="title-content p-d-flex">
            <div class="p-col">
              <!-- タイトル -->
              <div class="p-grid title">
                <div class="p-col-7 thread-title">{{ detailThread?.title }}</div>
                <div class="p-col-2 thread-post-count p-text-right">
                  <span>新着{{detailThread?.post_count_since_last_view }} (全{{ detailThread?.posts_count }}件)</span>
                </div>
                <div class="p-col-2 thread-name p-text-right">{{ detailThread?.organization_name }}</div>
                <div class="p-col-1 menu-container" *ngIf="loginUser && memberClassId != 3">
                  <span (click)="toggleDropdown()" class="ellipsis-icon">操作 <i class="pi pi-chevron-down"></i></span>
                  <div class="dropdown-menu" *ngIf="isDropdownOpen">
                    <div class="dropdown-item" *ngIf="(loginUserId == detailThread?.user_id)" (click)="deleteThread(detailThread.thread_id)">削除</div>
                    <div class="dropdown-item" *ngIf="!(loginUserId == detailThread?.user_id)" (click)="reportThread(detailThread.thread_id)">スレッドを通報</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="posts-section">
          <!-- Paginated Posts Table -->
          <p-table
            #postsTable
            [value]="detailThread?.posts"
            [paginator]="showPaginator"
            [rows]="100"
            [totalRecords]="detailThread?.posts_count"
            [lazy]="true"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="{first}~{last}件表示({totalRecords}件中)"
            [rowsPerPageOptions]="[50, 100, 500, 1000]"
            (onLazyLoad)="getDetailThread($event)"
            (onPage)="jumpTop()"
          >
            <!-- Table Body -->
            <ng-template pTemplate="body" let-post let-rowIndex="rowIndex">
              <tr>
                <td class="post-item">
                  <div class="post-header">
                    <span class="post-number">{{ (rowIndex + 1) }}</span>
                    <span class="post-date">{{ convertToJST(post?.create_datetime) }}</span>
                    <span class="post-organization">
                      {{ getDisplayName(post) }}
                    </span>
                    <span class="post-action-button">
                      <div class="post-menu-container" *ngIf="loginUser">
                        <span *ngIf="loginUser && memberClassId != 3 && post.class_id == 3"
                              class="button1 p-button talk-button"
                              (click)="requestMoreDetailsDialog(post.post_id)"
                        >話を聞きたい</span>
                        <span (click)="togglePostDropdown(rowIndex)" class="ellipsis-icon">操作 <i class="pi pi-chevron-down"></i></span>
                        <div class="dropdown-menu" *ngIf="activeDropdownIndex === rowIndex">
                          <div class="dropdown-item" *ngIf="getLoginUserId() == post.user_id" (click)="deletePost(post.post_id)">削除</div>
                          <div class="dropdown-item" *ngIf="!(getLoginUserId() == post.user_id)" (click)="reportPost(post.post_id)">書き込みを通報</div>
                        </div>
                      </div>
                    </span>
                  </div>
                  <div class="post-content">
                    {{ post.content }}
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="4">データが存在しません</td>
              </tr>
            </ng-template>

          </p-table>
        </div>

        <div *ngIf="!loginUser" class="no-login-post-message" style="text-align: center; margin-top: 1rem;">
            他の投稿や書き込みにはログインが必要となります。
        </div>

        <div *ngIf="loginUser" class="post-new-container">
          <form [formGroup]="l201PostInputForm">
            <div class="post-input-container">
              <div class="information-Form-inputtext-wMaxarea">
                <textarea pInputTextarea formControlName="content"></textarea>
                <!-- エラーメッセージ出力箇所 -->
                <app-validator-message [control]="l201PostInputForm.get('content')"></app-validator-message>
              </div>
            </div>
            <div class="post-button-container p-text-right">
              <p-checkbox *ngIf="loginUser && memberClassId != 3"
                id="is_anonymous"
                label="匿名投稿"
                [binary]="true"
                [(ngModel)]="isAnonymousChecked"
                (onChange)="onAnonymousChange($event)"
                [ngModelOptions]="{standalone: true}"
              ></p-checkbox>

              <button
                pButton
                type="button"
                label="書き込む"
                class="button1 post-button"
                (click)="newPost()"
              ></button>
            </div>
          </form>
        </div>

      </div>
    </div>

  </div>
</div>

<!-- 共通部品_承認時ダイアログ -->
<app-report-dialog
  (returnReport)="getDetailInquiry()"
></app-report-dialog>

<!-- 共通部品_承認時ダイアログ -->
<app-confirm-request-more-details-dialog></app-confirm-request-more-details-dialog>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
